/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MyAccountState, MyAccountTypes } from 'store/modules/my_account_store/types';
import { Container } from './styles';

const ModalSuccessSolicitation = () => {
  const dispatch = useDispatch();

  const { my_account } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );

  return (
    <Modal className="m-0" show={my_account?.modalSuccess}>
      <Container>
        <div className="" tabIndex={-1} role="dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Solicitação enviada</h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() =>
                  dispatch({ type: MyAccountTypes.MODAL_SUCCESS, modal_success: false })
                }
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="alert alert-success text-center" role="alert">
                Solicitação enviada com sucesso.
              </div>
              <p>
                Sua solicitação foi enviada para nossos consultores e você será notificado em até
                <strong> 48 horas.</strong>
              </p>
              <p>
                Você pode acompanhar seu pedido em{' '}
                <a
                  href="/minha_conta/solicitacoes"
                  onClick={() =>
                    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'solicitation' })
                  }
                >
                  Minhas solicitações
                </a>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalSuccessSolicitation;
